import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withFetch,
    withInterceptorsFromDi,
} from '@angular/common/http';
import {
    APP_ID,
    ApplicationConfig,
    ErrorHandler,
    provideZoneChangeDetection,
} from '@angular/core';
import { MAT_LUXON_DATE_ADAPTER_OPTIONS } from '@angular/material-luxon-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import {
    provideClientHydration,
    withEventReplay,
    withNoHttpTransferCache,
} from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
    provideRouter,
    withComponentInputBinding,
    withInMemoryScrolling,
    withPreloading,
    withRouterConfig,
    withViewTransitions,
} from '@angular/router';
import { GlobalErrorHandler } from '@core/error-handlers/global.error-handler';
import { TokenInterceptor } from '@core/interceptors/auth.interceptor';
import {
    LOCALSTORAGE,
    LocalStorageService,
} from '@core/services/local-storage.service';
import { WINDOW, WindowService } from '@core/services/window.service';
import { quicklinkProviders, QuicklinkStrategy } from 'ngx-quicklink';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        { provide: APP_ID, useValue: 'angular-universal' },
        {
            provide: WINDOW,
            useFactory: (windowService: WindowService) =>
                windowService.nativeWindow,
            deps: [WindowService],
        },
        {
            provide: LOCALSTORAGE,
            useFactory: (localStorageService: LocalStorageService) =>
                localStorageService.localStorage,
            deps: [LocalStorageService],
        },
        { provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        provideClientHydration(withNoHttpTransferCache(), withEventReplay()),
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
        quicklinkProviders,
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            appRoutes,
            withPreloading(QuicklinkStrategy),
            withInMemoryScrolling({
                scrollPositionRestoration: 'enabled',
                anchorScrolling: 'enabled',
            }),
            withRouterConfig({
                paramsInheritanceStrategy: 'always',
                onSameUrlNavigation: 'reload',
            }),
            withViewTransitions(),
            withComponentInputBinding()
        ),
    ],
};
